// extracted by mini-css-extract-plugin
export default {"wrapper":"p_bG","textWrapper":"p_bH"};